<ion-list>
  <ion-spinner *ngIf="retrieving_diagnostics" name="bubbles"></ion-spinner>
  <ion-item *ngFor="let key of diagnosticKeys()">
    <ion-label>{{diagnostics_data[key].title}}</ion-label>
    <ion-label slot="end">{{ diagnostics_data[key]["value"] !== undefined ? diagnostics_data[key]["value"] : 'N/A'}} {{diagnostics_data[key].label}}</ion-label>
  </ion-item>
</ion-list>
